import { ToastContainerProps } from "react-toastify";
import logo_1 from "@/assets/images/logo/logo_01.svg";
import dayjs from "dayjs";

export const getAcademicYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // january =0; april=3
  //Academic Year start on April 1
  const startYear = month >= 3 ? year : year - 1;
  const endYear = startYear + 1;
  // console.log("🚀 ~ getAcademicYear ~ endYear:", endYear)
  // console.log(`🚀 ~ getAcademicYear ~ dayjs(endYear).format("YY"):`, dayjs().year(endYear).format('YY'))
  return `${startYear}-${dayjs().year(endYear).format("YY")}`;
};

// export const ACADEMICYEAR = "2025-26";
export const ACADEMICYEAR = getAcademicYear();

export const DEVOTP = 1902;

export const CommonConstant = {
  REFRESH_TOKEN: "refresh_token",
  MOBILE_NO: "Mobile No",
  VARIABLE: "variable",
  TEMPLATE_TAG: "template-tag",
  EMAIL: "email",
  NAME: "name",
  CATEGORY: "category",
  VOCATIONAL_TRAINER: "Vocational Trainer",
  SUCCESS: "success",
  STATUS0300: "0300",
  STATUS0399: "0399",
  VENUE_SCHOOL: "Venue School",
  SCHOOL: "School",
  PERCENTAGE: "Percentage",
  SMSSUCCESSMESSAGE: "Success",
  SMSSUCCESSCODE: "000",
  OK: "OK",
  PAYMENT_PROCESSING_ERROR: "payment_processing_error",
  SPONSORSHIPURL: "sponsorshipURL",
  SHARING: "Sharing",
  DATEFORMATE_YMD: "YYYY-MM-DD",
  DATEFORMATE_DMY: "DD-MM-YYYY",
  TNC: "TNC",
  OTHERS: "OTHERS",
  OTHERS_CAPITALIZED: "Others",
  OTHERS_LOWER: "others",
  DIRECT: "DIRECT",
  OLYMPIA: "Olympia",
  non_vibgyor_student: "non-vibgyor-student",
  vibgyor_student: "vibgyor-student",
  non_vibgyor_parent: "non-vibgyor-parent",
  vibgyor_parent: "vibgyor-parent",
  female: "female",
  male: "male",
  F: "F",
  non_vibgyor_faculty: "non-vibgyor-faculty",
  vibgyor_faculty: "vibgyor-faculty",
  Triple_Occupancy: "Triple Occupancy",
  Double_Occupancy: "Double Occupancy",
  DATE_TIME_FORMATE: "yyyy-MM-dd HH:mm:ss",
  ZONE: "Asia/Kolkata",
  VIVA_VIBGYOR: "VIVA VIBGYOR",
  Gender: "Gender",
  BULKUPLOAD: "bulkUpload",
  Participant: "Participant",
  REGISTERED_MESSAGE:
    "Already Registered for this event. Please check your order history",
};

export const ADMIN_ROLE_CODES = [
  "202FA037",
  "201FC066",
  "202FA066",
  "201FC037",
];

export enum USER_ROLE {
  USER = "USER",
  VT = "VT",
  SPA = "SPA",
  ASPA = "ASPA",
  AGENT = "AGENT",
  ADMIN = "ADMIN",
  VOCATIONAL_TRAINER = "Vocational Trainer",
  Assistant_Coordinator = "Assistant Coordinator - SPA",
  Coordinator = "Coordinator - SPA",
  VC = "VC",
}

export const VISITOR_RESTRICTED_ROUTES: any = {
  USER: ["/bulk-upload"],
  AGENT: ["/schedule", "/leaderboard", "/photos", "/videos", "/live"],
  // ADMIN: ["/v3/bulk-upload"], // bulkupload has billdesk as payment option admin doesn't have billdesk implementation so, restricted
  ADMIN: [],
};

// TODO: add staff's role afterwards
export const PRIVATE_PRODUCTS_ACCESS_ROLES = ["ADMIN"];

export const VIBGYOR_APP_NAME = "VIBGYOR_VIVA";

// Event-filter checkbox values that are actually Group Names (not fees_sub_type).
// These must be matched against an event's group_name rather than sub_type.
// export const GROUP_NAME_EVENT_OPTIONS = [
//   "The Stars Ensemble",
//   "The Junior Stars Ensemble",
// ];
export const BILLDESK_PAYMENT_LINK = "BILLDESK_PAYMENT_LINK";
export const RAZORPAY = "RAZORPAY";
export const BILLDESK = "BILLDESK";
export const DISCOUNT = "DISCOUNT";

export const SummerCampTypes = ["Full Day", "Half Day", "Flexible"];
export const SummerCampTypesTexts = [
  {
    label: "Summer Funfinity – Full Day Camp",
    value: "Full Day",
  },
  {
    label: "Summer Funfinity – Half Day Camp",
    value: "Half Day",
  },
  {
    label: "Pick-n-Play Camp",
    value: "Flexible",
  },
];
export const MultipleMonthsSummerCampSchools = [
  "vibgyor kids and high - balewadi",
];

export const GenderOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];

export const CalenderEventsColors = {
  selected: "#50C87850",
  // unselected: "#EE4B2B50",
  unselected: "#A7C7E750", // aka available
  // selectedBorder: "#50C878",
  selectedBorder: "#98FF98", // aka active/inuse
  unselectedBorder: "#EE4B2B",
  disableSelect: "#bdb9b9",
  timeSlotClash: "#fcdbd3",
};

export const ToastOptions: ToastContainerProps = {
  closeButton: false,
  hideProgressBar: true,
  autoClose: 4000,
  className: "custom-toast",
};

export const StudentTypes = [
  {
    label: "VIBGYOR STUDENT",
    value: "vibgyor-student",
  },
  {
    label: "NON-VIBGYOR-STUDENT",
    value: "non-vibgyor-student",
  },
];

// values in percentage such that price - (price * value) = discounted price
export const SummerCampDiscount: any = { 1: 0, 2: 0.05, 3: 0.13, 4: 0.2 };

export const PaymentStatus = {
  SUCCESS: "success",
  ACTIVE: "ACTIVE",
  FailedCanceled: "failed/canceled",
  PENDING: "pending",
  DRAFT: "draft",
};

export const initialFormData = {
  campType: "",
  venueSchool: null,
  campMonth: null,
  grade: null,
  gender: {
    label: "All",
    value: "All",
  },
  enrollmentNumber: "",
  studentType: null,
  venueType: { label: "All", value: "All" },
};
export const psaInitialFormData = {
  period: "",
  venueSchool: null,
  grade: null,
  gender: {
    label: "All",
    value: "All",
  },
  enrollmentNumber: "",
  studentType: null,
};

export const EventLegends = [
  {
    title: "Available event",
    color: CalenderEventsColors.unselected,
    camp_types_supported: ["Half Day", "Flexible"],
  },
  {
    title: "Selected event",
    color: CalenderEventsColors.selected,
    camp_types_supported: ["Half Day", "Flexible"],
  },
  {
    title: "Fully booked event",
    color: CalenderEventsColors.disableSelect,
    camp_types_supported: ["Half Day", "Flexible"],
  },
  {
    title: "Overlapping timeslot",
    color: CalenderEventsColors.timeSlotClash,
    camp_types_supported: ["Flexible"],
  },
];

export const PsaLegends = [
  {
    title: "Available",
    color: CalenderEventsColors.unselected,
  },
  {
    title: "Selected",
    color: CalenderEventsColors.selected,
  },
  {
    title: "Occupied",
    color: CalenderEventsColors.disableSelect,
  },
];

export enum APP_NAME {
  VIBGYOR_VIVA = "VIBGYOR_VIVA",
  VIBGYOR_MUN = "VIBGYOR_MUN",
  VIBGYOR_SUMMER_CAMPL = "VIBGYOR_SUMMER_CAMP",
  // VIBGYOR_ONE = "VIBGYOR_ONE",
  VIBGYOR_ONE = "VIBGYOR_ONE",
  SUMMER_CAMP_PRIVATE = "SUMMER_CAMP_PRIVATE",
}

export enum ONE_MODULES {
  VEMBARK = "VEMBARK",
  TOURS = "tours",
  EXTERNAL_EXAMINATION = "EXTERNAL_EXAMINATION",
  GI = "GI",
  VAFP = "vafp",
  VIVA_CONCERT_KIT = "VIVA_CONCERT_KIT",
  VSPA = "psa",
  VC3 = "VC3",
  VAFS = "vafs",
  SUMMER_CAMP = "summercamp",
  // SUMMER_CAMP = "summer-camp"
}
export enum OLYMPIA_MODULES {
  OLYMPIA_TOURS = "OLYMPIA_TOURS",
}

export enum ONE_LOGO {
  VEMBARK_LOGO = "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK_logo.jpg",
  TOURS_LOGO = "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/Olympia-Logo.jpg",
  EXTERNAL_EXAMS_LOGO = "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/External%20Exam%20logo.jpg",
  VIVA_CONCERT_KIT = "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK_logo.jpg",
  OLYMPIA_LOGO = "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/summer-camp-pass-logo.png",
}

export const EVENT_CARD_DEFAULT_IMG = {
  "summer-camp":
    "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Revised%20web%20banner/Web%20Page-02.jpg",
  psa: "https://storage.googleapis.com/eduspark-prod-viva-content/VSPA%20Web%20banner/VSPA%20Webbanner.jpg",
  VEMBARK:
    "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK/Banner1%20VEMBARK.jpg",
  tours:
    "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK/TOURIMG.jpg",
  EXTERNAL_EXAMINATION:
    "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK/External%20Exams/External%20Exams/External%20Exam%20logo%2008.jpg",
  GI: "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Events-imges/Advance%20Swimming/alemania_29.webp", // TODO add Global Incursion GI default image for event listing, event detail myorders page cards
  VAFP: "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Events-imges/Advance%20Swimming/alemania_29.webp", // TODO add Global Incursion GI default image for event listing, event detail myorders page cards
  13: "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Revised%20web%20banner/Web%20Page-02.jpg", // sc
  11: "https://storage.googleapis.com/eduspark-prod-viva-content/VSPA%20Web%20banner/VSPA%20Webbanner.jpg", //psa
  29: "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK/Banner1%20VEMBARK.jpg", //embark
  14: "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK/TOURIMG.jpg", //tours
  33: "https://storage.googleapis.com/eduspark-prod-viva-content/VIVA/VEMBARK/External%20Exams/External%20Exams/External%20Exam%20logo%2008.jpg", //ee
  22: "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Events-imges/Advance%20Swimming/alemania_29.webp", // TODO add Global Incursion GI default image for event listing, event detail myorders page cards
  VH_MUN: "",
  31: "", //mun
  VIVA: logo_1,
  public: logo_1,
  18: "", //viva
  "summer-camp-private":
    "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Revised%20web%20banner/Web%20Page-02.jpg",
  gi: "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Events-imges/Advance%20Swimming/alemania_29.webp",
  vafp: "https://storage.googleapis.com/eduspark-prod-viva-content/Summer-Camp/Events-imges/Advance%20Swimming/alemania_29.webp",
};

export const INVALID_PHONE_NUMBERS = [
  "0000000000",
  "1111111111",
  "1234567890",
  "9999999999",
  "2222222222",
  "3333333333",
  "4444444444",
  "5555555555",
  "6666666666",
  "7777777777",
  "8888888888",
  "1234567890",
  "0987654321",
  "9876543210",
  "0123456789",
];

export const NAV_FULL_FORM = {
  "V-EMBARK":
    "VIBGYOR’S – EDUCATIONAL MILESTONES BEYOND ACADEMICS REDEFINING KNOWLEDGE",
  VSPA: "VIBGYOR SPORTS AND PERFORMING ARTS",
  TGIP: "The Global Immersion Program",
  VC3: "VIBGYOR Career Counselling Cell",
  VAFP: "Vibgyor Ace Foundation Program",
};

export enum ORDER_TYPE {
  VEMBARK = "VEMBARK",
  TOURS = "tours",
  EXTERNAL_EXAMINATION = "EXTERNAL_EXAMINATION",
  VIVA_CONCERT_KIT = "VIVA_CONCERT_KIT",
  GI = "gi",
  VAFP = "vafp",
  VSPA = "psa",
  PUBLIC = "public",
  PRIVATE = "private",
  SUMMER_CAMP = "summer-camp",
  SUMMER_CAMP_PRIVATE = "summer-camp-private",
  VC3 = "VC3",
  OLYMPIA_TOURS = "OLYMPIA_TOURS",
}

export const CategoryOptions = [
  { value: "Group", label: "Group" },
  { value: "Individual", label: "Individual" },
];

export const AgeLimitsOptions = [
  { value: 6, label: "Under 6 years" },
  { value: 8, label: "Under 8 years" },
  { value: 10, label: "Under 10 years" },
  { value: 12, label: "Under 12 years" },
  { value: 15, label: "Under 15 years" },
  { value: 18, label: "Under 18 years" },
];

export const eventSubTypes = [
  { value: "Competition", label: "Competition" },
  { value: "Workshop", label: "Workshop" },
  { value: "Premier Competition", label: "Premier Competition" },
  { value: "Premier Sports", label: "Premier Sports" },
  { value: "Sports", label: "Sports" },
];

//OrderStatus Enum
export enum OrderStatus {
  DRAFT = "draft",
  ACTIVE = "ACTIVE",
  ACTIVE_LINK = "ACTIVE_LINK",
  PDF_GENERATION_PENDING = "pdf-generation-pending",
  PAID = "paid",
  FAILED = "failed",
  FAILED_UPPER = "FAILED",
  CANCELED = "canceled",
  USER_NOT_FOUND = "user-not-found", // this case occurs because the studentdatas collection was refreshed and we dont get the user
  EVENT_NOT_FOUND = "event-not-found",
  SWAPPED = "SWAPPED",
  CHEQUE_APPROVED = "CHEQUE_APPROVED", // specific for cheque orders
  APPROVAL_PENDING = "APPROVAL_PENDING", // specific for cheque orders
  PENDING = "PENDING",
  PENDING_LOWER = "pending",
  ACCEPTED_SUCCESS = "ACCEPTED_SUCCESS",
  FAIL = "FAIL",
  SUCCESS = "SUCCESS",
  SUCCESS_LOWER = "Success",
  REFUND_PENDING = "REFUND_PENDING",
  CHEQUE_APPROVED_CAPITALIZED = "Cheque Approved",
  WAITINGLIST = "waitinglist",
}

export enum PaymentType {
  BILLDESK = "BILLDESK",
  EDC = "EDC",
  CASH = "CASH",
  DISCOUNT = "DISCOUNT",
  BILLDESK_PAYMENT_LINK = "BILLDESK_PAYMENT_LINK",
  SWAPPED = "SWAPPED",
  CHEQUE = "CHEQUE",
  RAZORPAY = "RAZORPAY",
  PAYMENT_LINK = "PAYMENT_LINK",
}

export enum CampType {
  Flexible = "Flexible",
  Full_Day = "Full Day",
  Half_Day = "Half Day",
}

export enum ENV {
  DEV = "DEV",
  UAT = "UAT",
  PROD = "PROD",
  prod = "prod",
  uat = "uat",
  dev = "dev",
}

export enum OrderHistoryStatus {
  Pending = "Pending",
  Success = "Success",
  FailedOrCanceled = "Failed/Canceled",
  Null = "null",
}
export enum METABASEPARAMS {
  VIVA_METABASE_PARAM_ZONE = "VIVA_METABASE_PARAM_ZONE",
  VIVA_METABASE_PARAM_SCHOOL_ID = "VIVA_METABASE_PARAM_SCHOOL_ID",
  VIVA_METABASE_PARAM_FEE_CATEGORY = "VIVA_METABASE_PARAM_FEE_CATEGORY",
  VIVA_METABASE_PARAM_SUB_TYPE = "VIVA_METABASE_PARAM_SUB_TYPE",
  VIVA_METABASE_PARAM_PARTICIPATION_TYPE = "VIVA_METABASE_PARAM_PARTICIPATION_TYPE",
  VIVA_METABASE_PARAM_IS_PRIVATE = "VIVA_METABASE_PARAM_IS_PRIVATE",
  VIVA_METABASE_PARAM_GROUP_NAME = "VIVA_METABASE_PARAM_GROUP_NAME",
  VIVA_METABASE_PARAM_GRADE = "VIVA_METABASE_PARAM_GRADE",
  VIVA_METABASE_PARAM_AGE = "VIVA_METABASE_PARAM_AGE",
}

export enum ClassificationTypes {
  INDIVIDUAL = "INDIVIDUAL",
  GROUP = "GROUP",
  Individual = "Individual",
  Group = "Group",
  Male = "Male",
  Female = "Female",
  Others = "Others",
  All = "All",
  ALL = "ALL",
  PM = "PM",
  AM = "AM",
}
export enum SectionType {
  BANNER = "Banner",
  FOOTER = "Footer",
  SOCIAL_MEDIA = "Social Media",
  COMMITTEES = "Committees",
}

export enum PageName {
  ABOUT_US = "About us",
  HOME_PAGE = "Home Page",
  ABOUT = "About",
  VIBGYOR_MUN_15 = "VIBGYOR MUN 15",
}

export enum FooterLinkType {
  LINK_1 = "Link 1",
  LINK_2 = "Link 2",
  LINK_3 = "Link 3",
}

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export enum ContentType {
  JSON = "application/json",
  FORM_URLENCODED = "application/x-www-form-urlencoded",
  MULTIPART = "multipart/form-data",
  PDF = "application/pdf",
  JOSE = "application/jose",
  OCTET_STREAM = "application/octet-stream",
}

export enum WebAPPName {
  SummerCamp = "Summer Camp",
}

export enum ReceiptPrifix {
  FR = "FR",
}
export enum ParticipantFolderPrefix {
  GOV_ID = "PARTICIPANTS-GOV-IDS",
  AUDITION_VIDEO = "PARTICIPANTS-AUDITION-VIDEOS",
}

export const PaymentOptionsByRole = {
  agent: ["BILLDESK", "PAYMENT_LINK"],
  admin: ["CASH", "CHEQUE", "PAYMENT_LINK", "EDC"],
};

export enum PaytmStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PENDING_LOWER = "pending",
  FAILED_LOWER = "failed",
  CANCELED = "canceled",
  PAID = "PAID",
  DRAFT = "DRAFT",
  PDF_GENERATION_PENDING_UPPER = "PDF_GENERATION_PENDING",
  PDF_GENERATION_PENDING = "pdf-generation-pending",
  FAIL = "FAIL",
  ACTIVE = "ACTIVE",
  REFUND_INITIATED = "refund_initiated",
  REFUND_PENDING = "REFUND_PENDING",
  ACCEPTED_SUCCESS = "ACCEPTED_SUCCESS",
}

export enum FileFormat {
  JPEG = "image/jpeg",
  PNG = "image/png",
  JPG = "image/jpg",
}

export enum EventType {
  INDIVIDUAL = "INDIVIDUAL",
  GROUP = "GROUP",
  PRIVATE = "PRIVATE",
  PRIVATE_LOWER = "private",
  PUBLIC = "public",
}

export const studentTypeOptionsTGIP = [
  { value: "vibgyor-student", label: "Vibgyor Student" },
  { value: "non-vibgyor-student", label: "Non Vibgyor Student" },
  { value: "vibgyor-parent", label: "Vibgyor Parent" },
  { value: "non-vibgyor-parent", label: "Non Vibgyor Parent" },
];

const genderOptionsTGPI = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export enum Gender {
  MALE = "MALE",
  Male = "Male",
  male = "male",
  M = "M",
  FEMALE = "FEMALE",
  Female = "Female",
  female = "female",
  F = "F",
}

export const v3Sub_TYPE = "Sub Type";
export enum V3Attributes {
  INDIVIDUAL = "Individual",
  v3Sub_TYPE = "Sub Type",
}
export enum MdmAttributes {
  GRADE = "Grade",
  Group = "Group",
}

export enum DbConstants {
  TYPE_GROUP = "GROUP",
  TYPE_INDIVIDUAL = "INDIVIDUAL",
}

export const RAZORPAY_EVENTS = {
  PAYMENT_CAPTURED: "payment.captured",
  ORDER_PAID: "order.paid",
};

export const VALID_RAZORPAY_EVENTS = [
  RAZORPAY_EVENTS.PAYMENT_CAPTURED,
  RAZORPAY_EVENTS.ORDER_PAID,
];

export const SECONDRY_SMS_GATEWAY_API_KEY = "UgXBzM7EzkW9zy98Usb8cA";

export enum FeesId {
  GiFee_Id_22 = 22,
  VafpFee_Id_35 = 35,
  GiFee_Id_30 = 30,
}
export const REDIRECT_ROUTES = {
  CART: "/cart",
  PSA_REGISTER: "/psa/register",
  SUMMER_CAMP_REGISTER: "/summer-camp/register",
  VAFP_REGISTER: "/vafp/register",
  TGIP_REGISTER: "/tgip/register",
  V3_CART: "/cart",
  HOME: "/",
};

// all routes
// events/[[...slug]], la-voce, tgip, tgip/register, otp, home-six, login, v-embark, committees, psa, psa/register, glimpses/[...slug], glimpses, leaderboard/schools-ranking, leaderboard/group-winner/[id], leaderboard, faq, tours, payment, registration, about-us, photos/[...slug], photos, Event/[category]/[id], terms-and-conditions, secretariat, signup, page.tsx, viva-concert-kit, vc3, rules, orderhistory, orderhistory/[id], vafp, vafp/register, e-examination, summer-camp, summer-camp/register, v3/events/[[...slug]], v3/bulk-upload, v3/event/[[...slug]], v3/cart, videos, vibgyor-mun, contact-us, schedule, cart, live

export const APP_RESTRICTED_ROUTES: Record<string, string[]> = {
  [APP_NAME.VIBGYOR_VIVA]: [
    "/committees",
    "/glimpses",
    "/la-voce",
    "/registration",
    "/vibgyor-mun",
    "/e-examination",
    "/psa",
    "/summer-camp",
    "/tgip",
    "/tours",
    "/v-embark",
    "/vafp",
    "/viva-concert-kit",
    "/vc3",
  ],
  [APP_NAME.VIBGYOR_ONE]: [
    "/committees",
    "/contact-us",
    "/glimpses",
    "/leaderboard",
    "/la-voce",
    "/media",
    "/photos",
    "/schedule",
    "/v3",
    "/videos",
    "/vibgyor-mun",
    "/live",
    "/registration",
  ],
  [APP_NAME.SUMMER_CAMP_PRIVATE]: [
    "/committees",
    "/contact-us",
    "/e-examination",
    "/glimpses",
    "/la-voce",
    "/leaderboard",
    "/live",
    "/media",
    "/photos",
    "/psa",
    "/schedule",
    "/tgip",
    "/v-embark",
    "/v3",
    "/vafp",
    "/vibgyor-mun",
    "/videos",
    "/viva-concert-kit",
    "/vc3",
    "/registration",
  ],
};

export enum MetabaseParamsConst {
  Online = "Online",
  Offline = "Offline",
  Online_Space = "Online ",
  Offline_Space = "Offline ",
}

export const indianStates = [
  { name: "Andhra Pradesh", code: "AP" },
  { name: "Arunachal Pradesh", code: "AR" },
  { name: "Assam", code: "AS" },
  { name: "Bihar", code: "BR" },
  { name: "Chhattisgarh", code: "CG" },
  { name: "Goa", code: "GA" },
  { name: "Gujarat", code: "GJ" },
  { name: "Haryana", code: "HR" },
  { name: "Himachal Pradesh", code: "HP" },
  { name: "Jharkhand", code: "JH" },
  { name: "Karnataka", code: "KA" },
  { name: "Kerala", code: "KL" },
  { name: "Madhya Pradesh", code: "MP" },
  { name: "Maharashtra", code: "MH" },
  { name: "Manipur", code: "MN" },
  { name: "Meghalaya", code: "ML" },
  { name: "Mizoram", code: "MZ" },
  { name: "Nagaland", code: "NL" },
  { name: "Odisha", code: "OD" },
  { name: "Punjab", code: "PB" },
  { name: "Rajasthan", code: "RJ" },
  { name: "Sikkim", code: "SK" },
  { name: "Tamil Nadu", code: "TN" },
  { name: "Telangana", code: "TS" },
  { name: "Tripura", code: "TR" },
  { name: "Uttar Pradesh", code: "UP" },
  { name: "Uttarakhand", code: "UK" },
  { name: "West Bengal", code: "WB" },
  { name: "Andaman and Nicobar Islands", code: "AN" },
  { name: "Chandigarh", code: "CH" },
  { name: "Dadra and Nagar Haveli and Daman and Diu", code: "DN" },
  { name: "Delhi", code: "DL" },
  { name: "Jammu and Kashmir", code: "JK" },
  { name: "Ladakh", code: "LA" },
  { name: "Lakshadweep", code: "LD" },
  { name: "Puducherry", code: "PY" },
];

export const tshirtSizes = [
  { value: 6, label: "6" },
  { value: 8, label: "8" },
  { value: 10, label: "10" },
  { value: 12, label: "12" },
  { value: 14, label: "14" },
  { value: 16, label: "16" },
  { value: 18, label: "18" },
  { value: 20, label: "20" },
  { value: 22, label: "22" },
  { value: 24, label: "24" },
  { value: 26, label: "26" },
  { value: 28, label: "28" },
  { value: 30, label: "30" },
  { value: 32, label: "32" },
  { value: 34, label: "34" },
  { value: 36, label: "36" },
  { value: 38, label: "38" },
  { value: 40, label: "40" },
  { value: 42, label: "42" },
  { value: 44, label: "44" },
  // added extra value for css is ignoring last value
  // { value: 44, label: "44" },
];

export const tshirtSizesVivathon = [
  { value: 32, label: "XS" },
  { value: 34, label: "S" },
  { value: 36, label: "M" },
  { value: 38, label: "L" },
  { value: 40, label: "XL" },
  { value: 42, label: "XXL" },
  { value: 44, label: "XXXL" },
  // added extra value for css is ignoring last value
  // { value: 44, label: "XXXL" },
];

// Add Values from logic_name to get tShirt Input Field
export const tShirtVisibility = ["Junior Olympics", "Vivathon"];

export const periodNames = {
  Monthly: { label: "1 Month", noOfMonths: 1 },
  Quarterly: { label: "3 Months", noOfMonths: 3 },
  "Half Yearly": { label: "5 Months", noOfMonths: 5 },
  "One Time": { label: "One Time", noOfMonths: 1 },
  Annually: { label: "10 Months", noOfMonths: 10 },
};

export const VenueType = {
  Indoor: "Indoor",
  Outdoor: "Outdoor",
  Funfinity: "Funfinity",
  IndoorDayCamp: "Indoor Day Camp (Kids)",
  OutdoorDayCamp: "Outdoor Day Camp (Kids)",
  DayCamp: "Day Camp",
  IndoorHalfCamp: "Indoor Half Day Camp (Kids)",
  HalfCampKids: "Half Day Camp (Kids)",
  HalfCamp: "Half Day Camp",
  All: "All",
} as const;

export const VenueTypeOptions = [
  { label: "All", value: "All" },
  { label: "Indoor", value: "Indoor" },
  { label: "Outdoor", value: "Outdoor" },
];

export const emptyFilter = {
  eventsType: [],
  eventsMode: [],
  location: "",
  currentPage: 1,
  school: "",
  age: null,
  category: "",
  gender: "",
  zoneSearchBox: "",
  eventSearchBox: "",
  title: "",
  registrationsOpen: false,
  privateEvents: false,
  grade: null,
  school_id: [],
  venue_address: "",
};
